/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE API : PAGE BUTTONS : STYLES --------------- ++++++++++ */
export default theme => ({
    pagebuttons: {
        flex: '0',
        width: '100%',
        paddingTop: pxToEm(8),
        '& .button': {
            width: 'auto',
            '&.name-previous': { float: 'left' },
            '&.name-next': { float: 'right' }
        }
    }
});
